//Importaciones
import React, { useState } from "react";
import axios from "axios";
import "./file.css"; // Importa el archivo CSS
//Handler
const LoadVideos = () => {
  //Estados locales
  const [file, setFile] = useState(null);
  const [metadata, setMetadata] = useState({});
  const [name, setName] = useState("");
  const [isLoading, setIsLoading] = useState(null);
  //Formateo de fecha
  const parseDateFromName = (datePart, timePart) => {
    const year = parseInt(datePart.substring(0, 4));
    const month = parseInt(datePart.substring(4, 6)) - 1; 
    const day = parseInt(datePart.substring(6, 8));
    const hours = parseInt(timePart.substring(0, 2));
    const minutes = parseInt(timePart.substring(2, 4));
    const seconds = parseInt(timePart.substring(4, 6));
    return new Date(Date.UTC(year, month, day, hours, minutes, seconds));
  };
  //Carga y metadatos de archivo
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      
      const fileMetadata = {
        name: selectedFile.name,
        size: (selectedFile.size / (1024 * 1024)).toFixed(2) + " MB",
        type: selectedFile.type,
        lastModified: new Date(selectedFile.lastModified).toISOString(),
      };

      const dateMatch = selectedFile.name.match(/(\d{8})_(\d{6})/);
      if (dateMatch) {
        const startDate = parseDateFromName(dateMatch[1], dateMatch[2]);
        const lastModifiedDate = new Date(fileMetadata.lastModified);
        
        const convertToUTC0 = (dateString) => {
          const date = new Date(dateString);
          const timezoneOffset = date.getTimezoneOffset() * 60 * 1000;
          const utcTimestamp = date.getTime() + timezoneOffset;
          return new Date(utcTimestamp).toISOString();
        };

        const inicio = new Date(convertToUTC0(startDate));
        const final = new Date(fileMetadata.lastModified);
        
        fileMetadata.startDate = convertToUTC0(startDate);
        const durationMs = final.getTime() - inicio.getTime();
        const durationMinutes = Math.floor(durationMs / (1000 * 60));
        const durationSeconds = Math.floor((durationMs % (1000 * 60)) / 1000);
        
        fileMetadata.duration = `${durationMinutes} min ${durationSeconds} sec`;
        fileMetadata.endDate = lastModifiedDate.toISOString();

        const id = selectedFile.name.replace(/\.(mp4|mov)$/i, "");
        setName(id);
      } else {
        console.log("No se encontró una fecha válida en el nombre del archivo.");
      }

      setMetadata(fileMetadata);
    }
  };
  //Función carga de archivo - video
  const uploadFile = async () => {
    setIsLoading(true);
    if (!file) {
      alert("Selecciona un archivo para subir.");
      return;
    }
    try {
      console.log("Solicitando URL prefirmada...");
      const response = await axios.post(
        "https://legne6zwh1.execute-api.us-east-1.amazonaws.com/v1/assets/videos-cut-quality",
        {
          body: {
            key: `input_cut_videos/${name}.mp4`,
            contentType: file.type,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const res = response.data;
      const body = JSON.parse(res.body);
      const url = body.signedUrl;
      console.log("Subiendo archivo a S3...");
      const uploadResponse = await axios.put(url, file, {
        headers: {
          "Content-Type": file.type,
        },
      });

      if (uploadResponse.status < 300) {
        alert("Archivo subido exitosamente!");
        setIsLoading(null);
        window.location.reload();
      } else {
        alert("Error al subir el archivo.");
        setIsLoading(null);
      }
    } catch (err) {
      console.error("Error durante la carga:", err);
      alert("Ocurrió un error durante la carga.");
      setIsLoading(null);
    }
  };
  //Renderizado
  return (
    <div className="container">
      <div className="imagenes">
        <img className="imagenPrincipal" src="https://res.cloudinary.com/dfmsezslx/image/upload/v1734564047/logocenicana_jxy8tx.png" alt="Logo Cenicaña"></img>
        <img className="imagenSecundaria" src="https://res.cloudinary.com/dfmsezslx/image/upload/v1734637659/powerby_znidqs.png" alt="Logo Tecde"></img>
      </div>
      <h2 className="title">Cargar video de registros - Calidad de corte</h2>
      <input
        type="file"
        onChange={handleFileChange}
        accept="video/*"
        className="fileInput"
      />
      {file && (
        <div className="metadataContainer">
          <h3 className="subtitle">Metadatos del archivo</h3>
          <p><strong>Nombre:</strong> {metadata.name}</p>
          <p><strong>Tamaño:</strong> {metadata.size}</p>
          <p><strong>Tipo:</strong> {metadata.type}</p>
          <p>
            <strong>Última modificación:</strong>{" "}
            {new Date(metadata.lastModified).toLocaleString()}
          </p>
          <p>
            <strong>Inicio video:</strong>{" "}
            {new Date(metadata.startDate).toLocaleString()}
          </p>
          <p>
            <strong>Final video:</strong>{" "}
            {new Date(metadata.endDate).toLocaleString()}
          </p>
          {metadata.duration && (
            <p><strong>Duración:</strong> {metadata.duration}</p>
          )}
        </div>
      )}
      {isLoading && (
        <div className="loaderContainer">
          <div className="spinner"></div>
          <p className="loadingText">Cargando...</p>
          <p className="loadingText">Esto puede tardar unos minutos por el tamaño del video</p>
        </div>
      )}
      <button 
        onClick={uploadFile}
        className="uploadButton"
        disabled={!file}
      >
        Subir archivo
      </button>
    </div>
  );
};

export default LoadVideos;

